import axios from 'axios';
import router from "../router";
import store from '@/store/index';
let baseURL='';
export default ({requiresAtuh}) => {
    requiresAtuh = typeof requiresAtuh === 'undefined' ? true : requiresAtuh;

    const state = JSON.parse(localStorage.getItem('vuex-state'));
    let token=null;
    if (state && requiresAtuh) {
         token = state.token;
    }
     baseURL=   process.env.NODE_ENV === 'development'
        ? 'https://localhost:8084/api'
        : `https://${window.location.hostname}:8084/api`;


    const instance = axios.create({
        baseURL:baseURL,
        timeout: 180000,
        headers: {'Authorization': 'Bearer ' + token}
    })
    instance.defaults.baseURL=baseURL
    instance.defaults.showLoader = true;
    instance.interceptors.request.use(
        config => {
            if (config.showLoader) {
                store.dispatch('loader/pending');
            }
            return config;
        },
        error => {
            if (error.config?.showLoader) {
                store.dispatch('loader/done');
            }
            return Promise.reject(error);

        }
    );

    instance.interceptors.response.use((response) => {
        if (response.config?.showLoader) {
            store.dispatch('loader/done');
        }
        return response
    }, (error) => {
        if (error.config?.showLoader) {
            store.dispatch('loader/done');
        }
        if (!error.response) {
            router.push("/networkError");
        } else if (error.response.status === 403) {
            router.push("/page403");
        } else if (error.response.status === 500) {
            router.push("/page500");
        }
        else if (error.response.status === 404) {
            router.push('/error400')
        }
        else if (error.response.status === 401) {
            if(token)
                router.push('/error401')
        }
        else if (error.response.status === 423) {
            router.push('/error423')
        }
        else  {
            return  error

        }
        throw error;
    });


    return instance;


};
